<template lang="pug">
.oauth-handler
</template>

<script>
import * as log from 'loglevel';
import get from 'lodash/get';
import pick from 'lodash/pick';
import OAuth from '@/libs/mixins/OAuth';
import { randomString } from '@/libs/stringUtils';

const TAG = '[OAuthHandler]';

export default {
  name: 'OAuthHandler',
  mixins: [OAuth],
  data() {
    return {
      authenticated: false,
    };
  },
  props: {
    // Name of integration
    integration: {
      type: String,
      default: '',
    },
    // OAuth Configuration
    config: null,
    // Optional. If it is specified with 'docsign', it hits a different endpoint
    type: {
      type: String,
      default: null,
    },
  },
  emits: ['authenticated', 'failure'],
  async mounted() {
    try {
      // Should not be mounted without integration and config value
      if (!this.integration || !this.config) {
        throw new Error(`Invalid values: ${this.integration}, config: ${this.config}`);
      }

      // Check if we access token
      if (await this.checkConnection(this.type)) {
        return this.$emit('authenticated');
      }

      // authentication
      await this.onStartAuth(this.integration);
      this.authenticated = true;

      this.$emit('authenticated');
    } catch (err) {
      this.$aiq.notify.error(err.message);
      log.error(err);
      this.$emit('failure', err);
    }
  },
  methods: {
    async checkConnection(type) {
      let action = 'integrations/checkIntegrationConnection';
      if (type === 'docsign') {
        action = 'integrations/checkDocumentIntegrationConnection';
      }
      return await this.$store.dispatch(action, this.integration);
    },

    async tokenExchange(type, payload) {
      let action = 'integrations/tokenExchange';
      if (type === 'docsign') {
        action = 'integrations/documentTokenExchange';
      }
      return this.$store.dispatch(action, payload);
    },

    async onStartAuth(name) {
      // Start Authentication
      const state = randomString();
      let code_verifier;
      let params = null;

      log.debug(TAG, this.integration, 'oauth config:', this.config);

      // NOTE: The logic is only for authorization with PCKE.
      if (get(this.config, 'use_pkce', true)) {
        code_verifier = this.createCodeVerifier();
        params = {
          state,
          code_challenge: this.createCodeChallenge(code_verifier),
          ...pick(this.config, ['response_type', 'client_id', 'scope', 'redirect_uri', 'code_challenge_method']),
        };
      } else {
        params = { state, ...pick(this.config, ['response_type', 'client_id', 'scope', 'redirect_uri']) };
      }

      const url = this.oauth2Url(get(this.config, 'authorization_endpoint', ''), params);
      log.debug(TAG, this.integration, 'oauth url:', url, params);

      const code = await this.openOauth2Popup(url, this.integration);
      log.debug(TAG, this.integration, 'authorization code:', code);

      // exchange with access token
      return this.tokenExchange(this.type, { name, query: { code, state, code_verifier } });
    },
  },
};
</script>
